/**
 * Diccionario único de traducción del nivel de acceso a español.
 *
 * Cubre los valores canónicos en inglés (owner/admin/observer/suscriptor — los que
 * devuelve actor-contextowner.vinculado) y los legacy en español. Antes había 4 copias
 * divergentes (OrgSwitcher, GobiernoPage, HomePage, SelectCoPage) y ninguna traducía
 * 'owner' → se mostraba crudo en Gobierno. Un solo diccionario, sin ondular.
 */
export function formatNivel(nivel: string | null | undefined): string {
  if (!nivel) return 'Sin rol'
  const m: Record<string, string> = {
    owner: 'Propietario',
    propietario: 'Propietario',
    admin: 'Administrador',
    administrador: 'Administrador',
    observer: 'Observador',
    observador: 'Observador',
    suscriptor: 'Suscriptor',
    subscriber: 'Suscriptor',
  }
  return m[nivel.toLowerCase()] ?? nivel
}
